import { Form } from 'antd/lib'
import { AttributesBodyPropsType, AttributeValueType } from 'Types/Attribute.types'
import { getDefaultAttributeValue } from 'Utils/attributes.utils'
import { AttributesBody } from './AttributesBody'
import { useEffect } from 'react'

type AttributesFormWrapperPropsType = Omit<AttributesBodyPropsType, 'form'>

export const AttributesFormWrapper = (props: AttributesFormWrapperPropsType) => {
    const [form] = Form.useForm()

    useEffect(() => {
        props.setForm(form)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const values = props.attributes.reduce(
            (prev, curr) => {
                prev[curr.name] =
                    props.getValues?.()?.[curr.name]?.data?.value ??
                    getDefaultAttributeValue(curr.value_definition.value_type)
                return prev
            },
            {} as Record<string, AttributeValueType>
        )
        form.setFieldsValue(values)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, props.attributes, props.groupKey])

    return (
        <Form
            form={form}
            initialValues={props.attributes.reduce(
                (prev, curr) => {
                    prev[curr.name] =
                        props.getValues?.()?.[curr.name]?.data?.value ??
                        getDefaultAttributeValue(curr.value_definition.value_type)
                    return prev
                },
                {} as Record<string, AttributeValueType>
            )}
            layout="vertical"
            name={`attributes-form-${props.groupKey}`}
        >
            <AttributesBody {...props} form={form} />
        </Form>
    )
}
